import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdSearch } from 'react-icons/md';

const Search: React.FC<IconBaseProps> = (props) => <MdSearch {...props} />;

export default Search;
